import BaseListPresenter from "../../../../base/BaseListPresenter";

class StepIncrementPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const { data } = this.view.props;
    const id = data?.id ?? "";
    this.limit = 10;
    this.where = { "employee.id": id, cause: "STEP INCREMENT" };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  getGeneratedCSV(data, objects) {
    const { reportLists } = this.view.props;
    const headers = [
      "Surname",
      "Firstname",
      "Middlename",
      "From",
      "To",
      "Designation",
      "Status",
      "Salary",
      "Station",
      "Branch",
      "Cause",
    ];

    const rows = objects.map((obj) => [
      data.surname ?? "",
      data.Firstname ?? "",
      data.Middlename ?? "",
      obj.from ? new Date(obj.from).toLocaleDateString() : "",
      obj.to ? new Date(obj.to).toLocaleDateString() : "",
      obj.designation ?? "",
      obj.status ?? "",
      obj.salary
        ? obj.salary.match(/₱\s*([\d,]+\.\d{2})/)?.[1]?.replace(/,/g, "")
        : "",
      obj.station ?? "",
      obj.branch ?? "",
      obj.cause ?? "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${reportLists}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
export default StepIncrementPresenter;
